import { Translator } from 'Translator';
import { SubOption } from 'model/Filters';
import Logger from 'utils/Logger';

import activityTypeSubOptions from './activityTypeSubOptions';
import availabilitySubOptions from './availabilitySubOptions';
import cuisineSubOptions from './cusineSubOptions';
import durationSubOptions from './durationSubOptions';
import languagesSubOptions from './languagesSubOptions';
import priceSubOptions from './priceSubOptions';
import subCategoriesSubOptions from './subCategoriesSubOptions';
import transportationModeSubOptions from './transportationModeSubOptions';

const modules = import.meta.glob('../../../resources/tags.*.json', {
  eager: true,
  import: 'default',
});

let tagsFromApi = [];
try {
  const key = `../../../resources/tags.${ENVIRONMENT}.json`;
  tagsFromApi = modules[key] as any[];
} catch (e) {
  Logger.error(`Could not load tags for env: ${ENVIRONMENT}`);
  tagsFromApi = [];
}

const subOptions = [
  ...activityTypeSubOptions,
  ...availabilitySubOptions,
  ...cuisineSubOptions,
  ...durationSubOptions,
  ...languagesSubOptions,
  ...priceSubOptions,
  ...subCategoriesSubOptions,
  ...transportationModeSubOptions,
];

const hardcodedTags = [
  {
    id: 71,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.local-cuisine',
      {},
      true,
      'Local Cuisine',
    ),
    value: 'local-cuisines',
  },
  {
    id: 74,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.le-marais-tours',
      {},
      true,
      'Le Marais tours',
    ),
    value: 'le-marais-tours',
  },
  {
    id: 75,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.montserrat-day-trips',
      {},
      true,
      'Montserrat day trips',
    ),
    value: 'montserrat-day-trips',
  },
  {
    id: 76,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.private-pompei-day-trips',
      {},
      true,
      'Private Pompei day trips',
    ),
    value: 'private-pompei-day-trips',
  },
  {
    id: 77,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.shore-excursions',
      {},
      true,
      'Shore excursions',
    ),
    value: 'shore-excursions',
  },
  {
    id: 79,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.things-to-do-alone',
      {},
      true,
      'Things to do alone',
    ),
    value: 'things-to-do-alone',
  },
  {
    id: 80,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.things-to-do-at-night',
      {},
      true,
      'Things to do at night',
    ),
    value: 'things-to-do-at-night',
  },
  {
    id: 81,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.things-to-do-for-couples',
      {},
      true,
      'Things to do for couples',
    ),
    value: 'things-to-do-for-couples',
  },
  {
    id: 81,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.things-to-do-in-2-days',
      {},
      true,
      'Things to do in 2 days',
    ),
    value: 'things-to-do-in-2-days',
  },
  {
    id: 82,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.things-to-do-in-3-days',
      {},
      true,
      'Things to do in 3 days',
    ),
    value: 'things-to-do-in-3-days',
  },
  {
    id: 83,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.things-to-do-in-a-weekend',
      {},
      true,
      'Things to do in a weekend',
    ),
    value: 'things-to-do-in-a-weekend',
  },
  {
    id: 84,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.things-to-do-in-one-day',
      {},
      true,
      'Things to do in one day',
    ),
    value: 'things-to-do-in-one-day',
  },
  {
    id: 85,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.things-to-do-today',
      {},
      true,
      'Things to do today',
    ),
    value: 'things-to-do-today',
  },
  {
    id: 86,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.things-to-do-with-teenagers',
      {},
      true,
      'Things to do with teenagers',
    ),
    value: 'things-to-do-with-teenagers',
  },
  {
    id: 74,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.day-tour',
      {},
      true,
      'Day Tour',
    ),
    value: 'day-tours',
  },
  {
    id: 76,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.fishing',
      {},
      true,
      'Fishing',
    ),
    value: 'fishing',
  },
  {
    id: 77,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.surfing',
      {},
      true,
      'Surfing',
    ),
    value: 'surfing',
  },
  {
    id: 79,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.music-workshop',
      {},
      true,
      'Music Workshop',
    ),
    value: 'music-workshops',
  },
  {
    id: 710,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.half-day-trip',
      {},
      true,
      'Half Day Trip',
    ),
    value: 'half-day-trips',
  },
  {
    id: 711,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.wine-tasting',
      {},
      true,
      'Wine Tasting',
    ),
    value: 'wine-tastings',
  },
  {
    id: 716,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.skip-the-line',
      {},
      true,
      'Skip the line',
    ),
    value: 'skip-the-line',
  },
  {
    id: 717,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.bike-tour',
      {},
      true,
      'Bike tour',
    ),
    value: 'bike-tours',
  },
  {
    id: 719,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.hiking',
      {},
      true,
      'Hiking',
    ),
    value: 'hiking',
  },
  {
    id: 720,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.wildlife-tour',
      {},
      true,
      'Wildlife tour',
    ),
    value: 'wildlife-tours',
  },
  {
    id: 721,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.trekking',
      {},
      true,
      'Trekking',
    ),
    value: 'trekking',
  },
  {
    id: 722,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.boat-tour',
      {},
      true,
      'Boat tours',
    ),
    value: 'boat-tours',
  },
  {
    id: 723,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.beer-tasting',
      {},
      true,
      'Beer tastings',
    ),
    value: 'beer-tastings',
  },
  {
    id: 725,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.adventure-travel',
      {},
      true,
      'Adventure travel',
    ),
    value: 'adventure-travel',
  },
  {
    id: 726,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.highlights',
      {},
      true,
      'Highlights',
    ),
    value: 'highlights',
  },
  {
    id: 727,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.layover-tour',
      {},
      true,
      'Layover tours',
    ),
    value: 'layover-tours',
  },
  {
    id: 728,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.celebration',
      {},
      true,
      'Celebration',
    ),
    value: 'celebration',
  },
  {
    id: 729,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.nature-tour',
      {},
      true,
      'Nature tours',
    ),
    value: 'nature-tours',
  },
  {
    id: 730,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.tapas-tours',
      {},
      true,
      'Tapas tours',
    ),
    value: 'tapas-tours',
  },
  {
    id: 731,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.wine-tours',
      {},
      true,
      'Wine tours',
    ),
    value: 'wine-tours',
  },
  {
    id: 732,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.history-tours',
      {},
      true,
      'History tours',
    ),
    value: 'history-tours',
  },
  {
    id: 733,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.guided-tours',
      {},
      true,
      'Guided tours',
    ),
    value: 'guided-tours',
  },
  {
    id: 734,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.tours-by-locals',
      {},
      true,
      'Tours by Locals',
    ),
    value: 'tours-by-locals',
  },
  {
    id: 735,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.sightseeing-tours',
      {},
      true,
      'Sightseeing tours',
    ),
    value: 'sightseeing-tours',
  },
  {
    id: 736,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.market-tours',
      {},
      true,
      'Market tours',
    ),
    value: 'market-tours',
  },
  {
    id: 737,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.art-tours',
      {},
      true,
      'Art tours',
    ),
    value: 'art-tours',
  },
  {
    id: 738,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.beer-tours',
      {},
      true,
      'Beer tours',
    ),
    value: 'beer-tours',
  },
  {
    id: 739,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.airport-tours',
      {},
      true,
      'Airport Tours',
    ),
    value: 'airport-tours',
  },
  {
    id: 740,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.christmas-tours',
      {},
      true,
      'Christmas tours',
    ),
    value: 'christmas-tours',
  },
  {
    id: 761,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.scooter-tours',
      {},
      true,
      'Scooter tours',
    ),
    value: 'scooter-tours',
  },
  {
    id: 762,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.cultural-tours',
      {},
      true,
      'Cultural tours',
    ),
    value: 'cultural-tours',
  },
  {
    id: 763,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.private-drivers',
      {},
      true,
      'Private drivers',
    ),
    value: 'private-drivers',
  },
  {
    id: 764,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.street-art-tours',
      {},
      true,
      'Street art tours',
    ),
    value: 'street-art-tours',
  },
  {
    id: 765,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.museum-tours',
      {},
      true,
      'Museum tours',
    ),
    value: 'museum-tours',
  },
  {
    id: 766,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.food-tours-by-night',
      {},
      true,
      'Food tours by Night',
    ),
    value: 'food-tours-by-night',
  },
  {
    id: 767,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.hiking-tours',
      {},
      true,
      'Hiking tours',
    ),
    value: 'hiking-tours',
  },
  {
    id: 768,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.jungle-trekking',
      {},
      true,
      'Jungle trekking',
    ),
    value: 'jungle-trekking',
  },
  {
    id: 769,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.colosseum-tours',
      {},
      true,
      'Colosseum tours',
    ),
    value: 'colosseum-tours',
  },
  {
    id: 770,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.trastevere-tours',
      {},
      true,
      'Trastevere tours',
    ),
    value: 'trastevere-tours',
  },
  {
    id: 771,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.floating-market-tours',
      {},
      true,
      'Floating market tours',
    ),
    value: 'floating-market-tours',
  },
  {
    id: 772,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.gaudi-tours',
      {},
      true,
      'Gaudi tours',
    ),
    value: 'gaudi-tours',
  },
  {
    id: 773,
    name: Translator.translate(
      'Experience.SubcategoryOrTag.sagrada-familia-tours',
      {},
      true,
      'Sagrada Familia tours',
    ),
    value: 'sagrada-familia-tours',
  },
].filter(
  (subOption) =>
    !tagsFromApi.some((subOpt) => subOpt.value === subOption.value),
);

const tags = [...hardcodedTags, ...tagsFromApi];

// filter tag values on filter values so we won't have a conflict with existing filters
const tagSubOptions = tags.filter(
  (tag) => !subOptions.some((subOption) => subOption.value === tag.value),
) as SubOption[];

export default tagSubOptions;
